export const setupMetadataHover = (area: HTMLElement) => {
	const { getClosest } = pm.utils.dom;

	init();

	let fadingTimeoutId: number | null = null;

	function init() {
		area.addEventListener("mousemove", handleOverlayMousemove);
	}

	function handleOverlayMousemove(e: MouseEvent) {
		const target = e.target as HTMLElement | null;
		if (!target) return;

		const imageWrapper = getClosest(target, ".single-image-wrapper");
		if (!imageWrapper) return;
		switchMetaDataFading();
	}

	const metadataSelectors =
		".single-image-wrapper .gallery-metadata, .single-image-wrapper .gallery-author, .single-image-wrapper .gallery-instagram, .single-image-wrapper .gallery-location";

	/**
	 * Switch meta data fading.
	 */
	function switchMetaDataFading() {
		jQuery(metadataSelectors).fadeIn("200");

		if (null != fadingTimeoutId) {
			clearTimeout(fadingTimeoutId);
		}

		fadingTimeoutId = window.setTimeout(hidePopupMetaData, 1500);
	}

	/**
	 * Hide popup meta data.
	 */
	function hidePopupMetaData() {
		jQuery(metadataSelectors).fadeOut("200");
	}
};
